import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { CardActions, Button } from "@mui/material";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { useAlert } from "react-alert";

export default function BasicWeb({ drawerWidth }) {
	const { t } = useTranslation();
	const [generalData, setGeneralData] = useState({
		path: null,
	});
	const [loading, setLoading] = useState(false);
	const alert = useAlert();

	useEffect(() => {
		const getGeneralData = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "creator-iframe", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setGeneralData({
					path: res.data.path,
				});
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};

		getGeneralData();
	}, []);

	const saveGeneralData = async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creator-iframe",
				{
					...generalData,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
			alert.show(t("general.success"), { type: "error" });
		}
		setLoading(false);
	};

	const validatePath = (path) => {
		const pathPattern = /^\/[a-zA-Z0-9\-_]+$/;
		const uuidPattern =
			/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

		return (
			path &&
			path !== "applaby-iframe" &&
			path.length < 64 &&
			pathPattern.test("/" + path) &&
			!uuidPattern.test(path)
		);
	};

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					p: 3,
					width: { xs: "100%", sm: `calc(100vw - ${drawerWidth}px)` },
				}}
			>
				<Toolbar />

				<Grid container spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<Card variant="outlined" sx={{ marginBottom: 4 }}>
							<CardContent>
								<Typography
									sx={{
										fontSize: 14,
										borderBottom: "1px solid #f0f0f0",
										minHeight: "35px",
										marginLeft: "-20px",
										marginRight: "-20px",
										padding: "0px 20px 20px",
									}}
									color="text.secondary"
									gutterBottom
								>
									{t("basicWeb.howToUse")}
								</Typography>

								<>
									<Typography mb={2}>{t("basicWeb.description")}</Typography>

									{/* Campo para Subdominio */}
									<Typography sx={{ marginBottom: "10px" }}>
										{t("basicWeb.step1")}
									</Typography>
									<TextField
										id="subdomain-input"
										placeholder={t("basicWeb.domain")}
										variant="outlined"
										fullWidth
										value={generalData.path}
										sx={{ marginBottom: "20px" }}
										onChange={(e) => {
											setGeneralData({
												...generalData,
												path: e.target.value,
											});
										}}
										InputProps={{
											startAdornment: (
												<InputAdornment position="start">
													<Typography>https://book.applaby.com/</Typography>
												</InputAdornment>
											),
										}}
									/>
									<Typography sx={{ marginBottom: "10px" }}>
										{t("basicWeb.step2")}
									</Typography>
									<Typography sx={{ marginBottom: "10px" }}>
										{t("basicWeb.contact")}{" "}
										<a href="mailto:info@applaby.com">info@applaby.com</a>
									</Typography>
								</>
							</CardContent>
							<CardActions sx={{ justifyContent: "right" }}>
								<Button
									variant="contained"
									size="small"
									onClick={saveGeneralData}
									disabled={loading || !validatePath(generalData?.path || null)}
								>
									{loading ? <CircularProgress size={12} /> : t("general.save")}
								</Button>
							</CardActions>
						</Card>
					</Grid>
				</Grid>
			</Box>
		</>
	);
}
